import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import CartaServicoLogged from '../../../../components/auth/institucional/cartaservico'

function CartaServicoLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Módulo de Carta de Serviços ao Cidadão" />
                <HeaderLogged />
                <Container>
                   <CartaServicoLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default CartaServicoLoggedScreen;